var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z",
    fill: "#F7F7FC",
    fillOpacity: 0.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4809 11.6916C23.6868 11.605 23.9122 11.5751 24.1336 11.6051C24.355 11.6351 24.5643 11.7239 24.7398 11.8622C24.9152 12.0006 25.0504 12.1834 25.1312 12.3917C25.212 12.6 25.2355 12.8262 25.1992 13.0466L23.3092 24.5108C23.1259 25.6166 21.9125 26.2508 20.8984 25.7C20.05 25.2391 18.79 24.5291 17.6567 23.7883C17.09 23.4175 15.3542 22.23 15.5675 21.385C15.7509 20.6625 18.6675 17.9475 20.3342 16.3333C20.9884 15.6991 20.69 15.3333 19.9175 15.9166C17.9992 17.365 14.9192 19.5675 13.9009 20.1875C13.0025 20.7341 12.5342 20.8275 11.9742 20.7341C10.9525 20.5641 10.005 20.3008 9.2317 19.98C8.1867 19.5466 8.23754 18.11 9.23087 17.6916L23.4809 11.6916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.572f4e03c4730d58277152f43e52627e.svg";
export { ForwardRef as ReactComponent };